var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CONFERENCE_FAILED, CONFERENCE_JOINED } from '../base/conference/actionTypes';
import { SET_AUDIO_MUTED, SET_VIDEO_MUTED } from '../base/media/actionTypes';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { updateSettings } from '../base/settings/actions';
import { TRACK_ADDED, TRACK_NO_DATA_FROM_SOURCE } from '../base/tracks/actionTypes';
import { setDeviceStatusOk, setDeviceStatusWarning, setJoiningInProgress } from './actions';
import { isPrejoinPageVisible } from './functions';
/**
 * The redux middleware for {@link PrejoinPage}.
 *
 * @param {Store} store - The redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register(store => next => (action) => __awaiter(void 0, void 0, void 0, function* () {
    switch (action.type) {
        case SET_AUDIO_MUTED: {
            if (isPrejoinPageVisible(store.getState())) {
                store.dispatch(updateSettings({
                    startWithAudioMuted: Boolean(action.muted)
                }));
            }
            break;
        }
        case SET_VIDEO_MUTED: {
            if (isPrejoinPageVisible(store.getState())) {
                store.dispatch(updateSettings({
                    startWithVideoMuted: Boolean(action.muted)
                }));
            }
            break;
        }
        case TRACK_ADDED:
        case TRACK_NO_DATA_FROM_SOURCE: {
            const state = store.getState();
            if (isPrejoinPageVisible(state)) {
                const { track: { jitsiTrack: track } } = action;
                const { deviceStatusType, deviceStatusText } = state['features/prejoin'];
                if (!track.isAudioTrack()) {
                    break;
                }
                if (track.isReceivingData()) {
                    if (deviceStatusType === 'warning'
                        && deviceStatusText === 'prejoin.audioDeviceProblem') {
                        store.dispatch(setDeviceStatusOk('prejoin.lookGood'));
                    }
                }
                else if (deviceStatusType === 'ok') {
                    store.dispatch(setDeviceStatusWarning('prejoin.audioDeviceProblem'));
                }
            }
            break;
        }
        case CONFERENCE_FAILED:
            store.dispatch(setJoiningInProgress(false));
            break;
        case CONFERENCE_JOINED:
            return _conferenceJoined(store, next, action);
    }
    return next(action);
}));
/**
 * Handles cleanup of prejoin state when a conference is joined.
 *
 * @param {Object} store - The Redux store.
 * @param {Function} next - The Redux next function.
 * @param {Object} action - The Redux action.
 * @returns {Object}
 */
function _conferenceJoined({ dispatch }, next, action) {
    dispatch(setJoiningInProgress(false));
    return next(action);
}
